import packageJson from "../package.json";

const APP_VERSION = packageJson.version;

try {
  const oldVersion = localStorage.getItem("app_version");
  if (oldVersion !== APP_VERSION) {
    const hasLegacyData = localStorage.length > 0;

    // Clear all storage mechanisms
    localStorage.clear();
    sessionStorage.clear();

    // Clear cookies
    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name =
        eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
      if (name) {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname};`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${window.location.hostname};`;
      }
    });

    localStorage.setItem("app_version", APP_VERSION);

    if (oldVersion !== null || hasLegacyData) {
      window.location.reload();
    }
  }
} catch (e) {
  console.error("Error during version-based cache clear:", e);
}
